import { render, staticRenderFns } from "./ProductListItemLabel.vue?vue&type=template&id=730d1f9a"
import script from "./ProductListItemLabel.vue?vue&type=script&lang=js"
export * from "./ProductListItemLabel.vue?vue&type=script&lang=js"
import style0 from "./ProductListItemLabel.vue?vue&type=style&index=0&id=730d1f9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports